<template>
  <div>
    <b-form-group
      :label="$t('fields.status')"
      label-for="status"
    >
      <b-form-checkbox
        id="status"
        v-model="itemData.status"
        value="1"
        switch
      >
        {{ itemData.status === 1? $t('common.active') : $t('common.passive') }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'DepartmentsStatusCard',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    itemData() {
      return this.$store.getters['departments/dataItem']
    },
  },
}
</script>
